export default {
    return: {
        title: "Retornar",
        header: "Itens a serem devolvidos",
        message: "Os seguintes equipamentos da Empresa devem ser devolvidos. Após enviar este formulário, você será contatado separadamente para combinar a coleta e/ou envio. Seu gerente será informado sobre o status da sua devolução.",

        model: {
            address: {
                country: {
                    label: "País"
                }
            },
            exclude: {
                label: "Excluir da devolução"
            },
            textarea: {
                placeholder: "Motivo: aprovação do gerente, retorno anterior etc."
            },
            return_note: {
                label: "Notas de devolução",
                placeholder: "Opcional: Insira quaisquer observações sobre os itens a serem devolvidos."
            },
            additional_disposal: {
                label: "Você tem algum físico DXC registros que precisam ser descartados com segurança"
            },
            additional_item: {
                type: {
                    label: "Tipo",
                    options: {
                        "chair": "Cadeira",
                        "desk": "Mesa",
                        "desk riser": "Elevador de mesa",
                        "docking station": "Estação de acoplamento",
                        "footrest": "Apoio para os pés",
                        "headset": "Fone de ouvido",
                        "hdmi cable": "Cabo HDMI",
                        "keyboard": "Teclado",
                        "kvm switch": "Comutador KVM",
                        "lamp": "Lâmpada",
                        "laptop riser": "Elevador de laptop",
                        "monitor": "Monitor",
                        "mouse": "Rato",
                        "other": "Outro",
                        "speakerphone": "Viva voz",
                        "usb hub": "Hub USB",
                        "webcam": "Webcam",
                    }
                },
                detail: {
                    label: "Detalhe",
                    placeholder: "Detalhe"
                },
                quantity: {
                    label: "Quantidade",
                    placeholder: "Quantidade"
                }
            }
        },

        submitted: {
            title: "Retorno enviado",
            message: "Seu retorno foi enviado. Você será contatado separadamente sobre a coleta e/ou envio do item."
        },
        nothingToReturn: {
            title: "Informações de devolução",
            message: "No momento, você não tem nenhum item para devolver no Gear."
        },
        notEligible: {
            title: "Informações de devolução",
            message: "Neste momento, o Gear não pode processar o seu retorno. Entre em contato com seu gerente local ou equipe de RH sobre como devolver seus itens."
        },

        button: {
            add: {
                cta: "Adicionar item não listado"
            },
            submit: {
                processing: "Enviando",
                cta: "Enviar"
            }
        }
    }
}